interface ActivationProgressBarProps {
  completed: number;
  total: number;
}

export default function ActivationProgressBar({ completed, total }: ActivationProgressBarProps) {
  const percentage = Math.round((completed / total) * 100);

  return (
    <div className="mt-6">
      <div className="flex justify-between mb-1">
        <span className="text-sm font-medium text-primary dark:text-blue-400">
          Progreso de activación
        </span>
        <span className="text-sm font-medium text-primary dark:text-blue-400">
          {completed}/{total}
        </span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-2.5 dark:bg-slate-700">
        <div
          className="bg-primary h-2.5 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
